import React, { useState, useEffect } from 'react';
import useStyles from './styles';

import Header from '../../components/Header';
import Board from '../../components/Board';
import Modal from '../../components/Modal';
import TextInput from '../../components/TextInput';
import Button from '../../components/Button'
import {AiOutlinePlus} from 'react-icons/ai'

function Layout({data, board, members, onDataChange, onCardAdd, addingState, closeModal, onCardAddSubmit, onInvite}) {
  const c = useStyles();
  

  return (
    <>
      <Header newBoard></Header>
      <div className={"container "+ c.boardContainer}>
        <div className={c.boardInfo}>
          <h1>{board?.title}</h1>
          <div className={c.rightSide}>
            <div className={c.users}>
              
            </div>
            <Button type="button" onClick={onInvite && onInvite} title={"Add Member"}>
              <AiOutlinePlus></AiOutlinePlus>
              Invite
            </Button>
          </div>
        </div>
        <Board onCardAdd={onCardAdd} onDataChange={onDataChange} data={data}></Board>
      </div>

      <Modal title="Add Card" visible={addingState} onCancel={closeModal} onSubmit={onCardAddSubmit}>
          <TextInput name="title" label="Card Title" ></TextInput>
          <textarea name="description" placeholder="Description"></textarea>
      </Modal>
    </>
  );
}




export default Layout;